// extracted by mini-css-extract-plugin
module.exports = {"container":"Token_container__3QCk0","notice":"Token_notice__3tgnf"};